export const generateArray = (length = 2) =>
    Array.from({ length }, (_, i) => i + 1)
